import { render, staticRenderFns } from "./ReviewSignStep.vue?vue&type=template&id=3afc79e3&scoped=true"
import script from "./ReviewSignStep.vue?vue&type=script&lang=js"
export * from "./ReviewSignStep.vue?vue&type=script&lang=js"
import style0 from "./ReviewSignStep.vue?vue&type=style&index=0&id=3afc79e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc79e3",
  null
  
)

export default component.exports